/* ECKv3.36: header search pop-up panel — markup in snippets/eck-search-panel.liquid. */
class EckSearchPanel extends HTMLElement {
  connectedCallback() {
    if (this.panel) return;

    this.toggle = this.querySelector('[data-eck-search-toggle]');
    this.panel = this.querySelector('[data-eck-search-panel]');
    if (!this.toggle || !this.panel) return;

    this.iconOpen = this.toggle.querySelector('[data-eck-search-icon-open]');
    this.iconClose = this.toggle.querySelector('[data-eck-search-icon-close]');
    this.input = this.panel.querySelector('input[type="search"]');
    this.isOpen = false;

    // Hang the panel off the full-width header wrapper so it drops from the header's bottom edge.
    const wrapper = this.closest('.header-wrapper');
    if (wrapper) wrapper.append(this.panel);

    this.backdrop = document.createElement('div');
    this.backdrop.className = 'eck-search-panel-backdrop';
    this.backdrop.hidden = true;
    document.body.append(this.backdrop);

    this.toggle.setAttribute('role', 'button');
    this.toggle.setAttribute('aria-controls', this.panel.id);
    this.toggle.setAttribute('aria-expanded', 'false');

    this.onToggleClick = (event) => {
      event.preventDefault();
      this.isOpen ? this.close(true) : this.open();
    };
    this.onToggleKeydown = (event) => {
      if (event.key === ' ') {
        event.preventDefault();
        this.toggle.click();
      }
    };
    this.onBackdropClick = () => this.close(false);
    this.onDocumentPointerDown = (event) => {
      if (!this.isOpen || event.target === this.backdrop) return;
      if (this.panel.contains(event.target) || this.toggle.contains(event.target)) return;
      this.close(false);
    };
    this.onDocumentKeydown = (event) => {
      if (event.key === 'Escape' && this.isOpen) this.close(true);
    };
    this.onPanelFocusOut = () => {
      setTimeout(() => {
        const active = document.activeElement;
        if (!this.isOpen || !active || active === document.body) return;
        if (this.panel.contains(active) || this.toggle.contains(active)) return;
        this.close(false);
      });
    };

    this.toggle.addEventListener('click', this.onToggleClick);
    this.toggle.addEventListener('keydown', this.onToggleKeydown);
    this.backdrop.addEventListener('click', this.onBackdropClick);
    this.panel.addEventListener('focusout', this.onPanelFocusOut);
    document.addEventListener('pointerdown', this.onDocumentPointerDown);
    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  disconnectedCallback() {
    if (!this.panel) return;
    document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    document.removeEventListener('keydown', this.onDocumentKeydown);
    this.backdrop.remove();
    this.panel.remove();
    this.panel = null;
  }

  open() {
    this.mountYmm();
    this.isOpen = true;
    this.panel.hidden = false;
    this.backdrop.hidden = false;
    this.setToggleState(true);
    if (this.input) this.input.focus({ preventScroll: true });
  }

  close(returnFocus) {
    if (!this.isOpen) return;
    this.isOpen = false;
    const search = this.panel.querySelector('predictive-search');
    if (search && typeof search.close === 'function') search.close();
    this.panel.hidden = true;
    this.backdrop.hidden = true;
    this.setToggleState(false);
    if (returnFocus) this.toggle.focus({ preventScroll: true });
  }

  setToggleState(open) {
    this.toggle.setAttribute('aria-expanded', String(open));
    this.toggle.setAttribute('aria-label', open ? this.toggle.dataset.labelClose : this.toggle.dataset.labelOpen);
    if (this.iconOpen) this.iconOpen.classList.toggle('hidden', open);
    if (this.iconClose) this.iconClose.classList.toggle('hidden', !open);
  }

  // The finder fetches the product-tag dataset when it connects, so mount it only on first open.
  mountYmm() {
    const template = this.panel.querySelector('template[data-eck-ymm-template]');
    const slot = this.panel.querySelector('[data-eck-ymm-slot]');
    if (!template || !slot) return;
    slot.append(template.content.cloneNode(true));
    template.remove();

    const src = this.panel.dataset.ymmScript;
    // eck-ymm.js declares top-level consts, so it must never load twice (/search already includes it).
    if (!src || customElements.get('eks-ymm-finder') || document.querySelector('script[src*="/eck-ymm.js"]')) return;
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.append(script);
  }
}

customElements.get('eck-search-panel') || customElements.define('eck-search-panel', EckSearchPanel);
